<div [hidden]="!isTableRendered">
  <div class="page-title">{{ title | translate }}</div>

  <div class="table-container">
    <table #deploymentTable [id]="tableId" class="display"></table>
  </div>
</div>
